import { call, put, takeEvery } from "redux-saga/effects";
import resources from "../../../config/resources";
import config from "../../../config/index";
import fetchService from "../../../lib/fetchService";
import { CANCEL_JOB_REQUEST, cancelJobError, cancelJobSuccess } from "./action";
import { handleSagaError } from "../../../dataproviders/errorResponseHandler";

const requestSaga = function*({ payload }) {
  const { job } = payload;

  const url = `${config.urls.BACKEND}/v2/${resources.JOBS}/${encodeURIComponent(job)}/cancel`;

  try {
    const response = yield call(fetchService.post, url);

    for (const action of yield call(handleSagaError, response, cancelJobError)) {
      yield put(action);
      return;
    }

    if (response.ok) {
      const responseData = yield call(() => response.json());
      yield put(cancelJobSuccess(responseData));
    } else {
      const statusCode = response.status;
      yield put(cancelJobError(new Error(`Request failed with error ${statusCode}!`)));
    }
  } catch (e) {
    yield put(cancelJobError(e));
  }
};

export default function*() {
  yield takeEvery(CANCEL_JOB_REQUEST, requestSaga);
}
